import {FC, useEffect, useMemo, useState} from "react";
import styles from "./DocumentsMenu.module.sass";
import {Search} from "components-new";
import {Link} from "react-router-dom";
import {organizationsAPI} from "../../libs/apiClient/Organizations";

interface DocumentsMenuProps {
	close: (state: any) => void;
}

export const DocumentsMenu: FC<DocumentsMenuProps> = ({ close }) => {
	const [searchValue, setSearchValue] = useState<string>("");
	const [organizationList, setOrganizationList] = useState<any[]>([]);

	useEffect(() => {
		organizationsAPI.documentsList().then((r) => {
			setOrganizationList(r.data);
		});
	}, []);

	const filterList = useMemo((): any[] => {
		return organizationList.filter(
			(item) =>
				item.fullName.toLowerCase().includes(searchValue.trim().toLowerCase()) ||
				item.shortName.toLowerCase().includes(searchValue.trim().toLowerCase()),
		);
		//eslint-disable-next-line
	}, [searchValue]);

	return (
		<div className={styles.menu}>
			<div className={styles.header}>
				<span className={styles.title}>Доступные организации</span>
				<Search
					className={styles.search}
					searchValue={searchValue}
					handleSearch={(e) => setSearchValue(e.target.value)}
				/>
			</div>
			<ul className={styles.list}>
				{!organizationList.length && <span className={styles.warning}>Ничего не найдено</span>}
				{searchValue.trim() ? (
					filterList.length ? (
						filterList.map((item: any) => (
							<li key={item.id}>
								<Link to={`documents/current/${item.id}/folders`} onClick={close} className={styles.item}>
									<span>{item.shortName}</span>
								</Link>
							</li>
						))
					) : (
						<span className={styles.warning}>Ничего не найдено</span>
					)
				) : (
					organizationList.map((item) => (
						<li key={item.id}>
							<Link to={`documents/current/${item.id}/folders`} onClick={close} className={styles.item}>
								<span>{item.shortName}</span>
							</Link>
						</li>
					))
				)}
			</ul>
		</div>
	);
};
